import { render, staticRenderFns } from "./physics.vue?vue&type=template&id=056165f8&scoped=true"
import script from "./physics.vue?vue&type=script&lang=js"
export * from "./physics.vue?vue&type=script&lang=js"
import style0 from "./physics.vue?vue&type=style&index=0&id=056165f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056165f8",
  null
  
)

export default component.exports